<template>
  <font-awesome-icon
    v-if="icon"
    :icon="getIcon"
    v-bind="$attrs"
    v-on="$listeners"
    :class="`cursor-pointer ${getVariant} font-weight-light ${getStateControl && getAnimation}`"
    :size="size"
    @mouseover="mouseOver"
  />
</template>

<script>
export default {
  props: {
    animationFormat: {
      type: String,
      default: 'round'
    },
    animationControl: {
      type: String
    },
    variant: {
      type: String,
      default: 'default'
    },
    size: {
      type: String,
      default: 'sm'
    },
    icon: {
      type: String,
      default: 'default'
    },
    animation: {
      type: String,
      default: 'default'
    }
  },
  data() {
    return {
      isPulse: true
    };
  },
  computed: {
    getIcon() {
      const registerIcons = {
        info: ['fas', 'fa-circle-exclamation'],
        help: ['fas', 'fa-circle-question'],
        danger: ['fas', 'circle-xmark']
      };
      return registerIcons[this.icon] || registerIcons['help'];
    },
    getAnimation() {
      const registerAnimations = {
        pulse: 'pulse',
        default: ''
      };
      if (this.animationFormat) {
        return (
          `${registerAnimations[this.animation]} ${this.animationFormat}` ||
          `${registerAnimations['default']} ${this.animationFormat}`
        );
      }
      return registerAnimations[this.animation] || registerAnimations['default'];
    },
    getVariant() {
      const options = {
        primary: 'text-primary',
        default: 'text-muted',
        secondary: 'text-secondary',
        danger: 'text-danger'
      };
      return options[this.variant] || options['default'];
    },
    getStateControl() {
      return this.animationControl ? (this.animationControl === 'on' ? true : false) : this.isPulse;
    }
  },
  methods: {
    mouseOver() {
      if (this.animationControl) return;
      this.isPulse = false;
    }
  }
};
</script>

<style scoped></style>
